"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildOutboundPaymentFailedMockData = exports.buildOutboundPaymentPostedMockData = exports.buildReceivedCreditMockData = exports.buildTreasuryBetaInvitationMockData = exports.buildLowTreasuryBalanceMockData = exports.buildBeneficiaryAddedMockData = exports.buildFinancialAccountCreatedMockData = exports.buildIssuingRewardSucceededMockData = exports.buildIssuingTopupSucceededMockData = exports.buildIssuingExpenseFailedMockData = exports.buildIssuingCardActivatedMockData = exports.buildIssuingCardOnTheWayMockData = void 0;
const organization_facing_base_1 = require("./organization-facing-base");
const buildIssuingCardOnTheWayMockData = ({ locale = "en", subject = "Your Zeffy Cash-Back Card is on the way!", address = "1250 René-Lévesque Blvd W, Suite 2200", city = "Montreal", postalCode = "H3B 4W8", region = "Quebec", country = "Canada", supportEmailUrl = "mailto:contact@zeffy.com", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    address,
    city,
    postalCode,
    region,
    country,
    supportEmailUrl,
});
exports.buildIssuingCardOnTheWayMockData = buildIssuingCardOnTheWayMockData;
const buildIssuingCardActivatedMockData = ({ locale = "en", subject = "Your Zeffy Cash-Back Card is now active!", } = {}) => (0, organization_facing_base_1.buildOrgFacingBase)(locale, subject);
exports.buildIssuingCardActivatedMockData = buildIssuingCardActivatedMockData;
const buildIssuingExpenseFailedMockData = ({ locale = "en", subject = "Your Zeffy Cash-Back Card purchase was declined", } = {}) => (0, organization_facing_base_1.buildOrgFacingBase)(locale, subject);
exports.buildIssuingExpenseFailedMockData = buildIssuingExpenseFailedMockData;
const buildIssuingTopupSucceededMockData = ({ locale = "en", subject = "Your funds are available", } = {}) => (0, organization_facing_base_1.buildOrgFacingBase)(locale, subject);
exports.buildIssuingTopupSucceededMockData = buildIssuingTopupSucceededMockData;
const buildIssuingRewardSucceededMockData = ({ locale = "en", subject = "Your monthly Zeffy rewards are available!", firstName = "John", amount = "$18.75", balanceUrl = "https://www.zeffy.com/en-CA/o/bank/payouts", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    firstName,
    amount,
    balanceUrl,
});
exports.buildIssuingRewardSucceededMockData = buildIssuingRewardSucceededMockData;
const buildFinancialAccountCreatedMockData = ({ locale = "en", subject = "Your financial account has been created!", } = {}) => (0, organization_facing_base_1.buildOrgFacingBase)(locale, subject);
exports.buildFinancialAccountCreatedMockData = buildFinancialAccountCreatedMockData;
const buildBeneficiaryAddedMockData = ({ locale = "en", subject = "You've successfully added a new beneficiary!", beneficiary = "Maple Leaf Catering", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    beneficiary,
});
exports.buildBeneficiaryAddedMockData = buildBeneficiaryAddedMockData;
const buildLowTreasuryBalanceMockData = ({ locale = "en", subject = "Your account balance is low", } = {}) => (0, organization_facing_base_1.buildOrgFacingBase)(locale, subject);
exports.buildLowTreasuryBalanceMockData = buildLowTreasuryBalanceMockData;
const buildTreasuryBetaInvitationMockData = ({ locale = "en", subject = "You're invited to the Zeffy financial account beta", bankUrl = "https://www.zeffy.com/en-CA/o/bank", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    bankUrl,
});
exports.buildTreasuryBetaInvitationMockData = buildTreasuryBetaInvitationMockData;
const buildReceivedCreditMockData = ({ locale = "en", subject = "You received a transfer!", senderName = "Bright Futures Foundation", amount = "$2,500.00", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    senderName,
    amount,
});
exports.buildReceivedCreditMockData = buildReceivedCreditMockData;
const buildOutboundPaymentPostedMockData = ({ locale = "en", subject = "Your transfer was successful", beneficiary = "Maple Leaf Catering", amount = "$1,200.00", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    beneficiary,
    amount,
});
exports.buildOutboundPaymentPostedMockData = buildOutboundPaymentPostedMockData;
const buildOutboundPaymentFailedMockData = ({ locale = "en", subject = "Your most recent transfer was unsuccessful", beneficiary = "Maple Leaf Catering", amount = "$1,200.00", } = {}) => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, subject),
    beneficiary,
    amount,
});
exports.buildOutboundPaymentFailedMockData = buildOutboundPaymentFailedMockData;
